<template>
  <router-view/>
</template>

<style lang="scss">
html,
body {
  min-height: 100%;
  background: #fff;
}
</style>
